import { formatPrice } from 'views/utils/converter';

export const multiplyNullable = (a: number | null, b: number | null): number | null => (a && b ? a * b : null);

export const formatPriceWithFallback = (price: number | null, fallback: string = '-', unit: string = '円') => {
  return `${formatPrice(price) ?? fallback}${unit}`;
};
